/**
 * LGM — product details panel
 * ---------------------------------------------------------------------------
 * Opening the panel itself needs no code: Prestige's DialogElement binds a
 * delegated click on `[aria-controls="<drawer id>"]`, so the trigger rows open
 * <x-drawer> on their own.
 *
 * The only thing missing is the reference's behaviour of opening the panel
 * with the CLICKED row already expanded — the panel lists every row, so
 * without this you would land on a stack of closed rows and have to find the
 * one you just asked for. This expands that row and collapses the others.
 *
 * Delegated on the document rather than bound per trigger, because the trigger
 * rows live in a `liquid` block, and `liquid` IS in ProductRerender's
 * partial-rerender list — the buttons are destroyed and rebuilt on every size
 * change, which would drop any listener attached directly to them.
 */

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-lgm-open]');
  if (!trigger) return;

  const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!drawer) return;

  const wanted = `lgm-details-section--${trigger.dataset.lgmOpen}`;

  drawer.querySelectorAll('.lgm-details-section').forEach((section) => {
    const disclosure = section.querySelector('details');
    if (!disclosure) return;

    const shouldOpen = section.classList.contains(wanted);
    disclosure.toggleAttribute('open', shouldOpen);
    /* The accordion snippet renders aria-expanded server-side; keep it honest
       for anything reading the panel before the first user toggle. */
    disclosure.setAttribute('aria-expanded', String(shouldOpen));
  });
});
